import { useState, useCallback } from 'react';
import API from 'api/api';

export default function useDisableUser() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const disableUser = useCallback(async (userId) => {
    setLoading(true);
    setError(null);

    try {
      await API.put(`/users/${userId}/disable`);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      return false;
    }
  }, []);

  return { disableUser, loading, error };
}
